export const LABELS = {
  reasonTextBox: {
    label: 'Informe aqui o motivo, se quiser',
    focusedLabel: 'Motivo'
  },
  submitProblemButton: 'Desalocar da coleta'
};

export default LABELS;
